// ⚠️ OWNER SETUP REQUIRED — EmailJS (Gmail notifications for form submissions)
// Step 1 — Go to https://www.emailjs.com and create a free account.
// Step 2 — Add Gmail as your Email Service → copy your Service ID.
// Step 3 — Create an Email Template → copy your Template ID. In the template,
//          reference these variables for the email body:
//            {{page}}, {{organization}}, {{contact_person}}, {{phone}},
//            {{email}}, {{reason}}
//          Recommended subject: "New Lancers Inquiry — {{organization}}"
// Step 4 — Go to Account → API Keys → copy your Public Key.
// Step 5 — Replace YOUR_PUBLIC_KEY, YOUR_SERVICE_ID, and YOUR_TEMPLATE_ID
//          below with your actual values, then rebuild/redeploy.

export const EMAILJS_PUBLIC_KEY = "YOUR_PUBLIC_KEY";
export const EMAILJS_SERVICE_ID = "YOUR_SERVICE_ID";
export const EMAILJS_TEMPLATE_ID = "YOUR_TEMPLATE_ID";

const isConfigured = () =>
  EMAILJS_PUBLIC_KEY &&
  !EMAILJS_PUBLIC_KEY.startsWith("YOUR_") &&
  EMAILJS_SERVICE_ID &&
  !EMAILJS_SERVICE_ID.startsWith("YOUR_") &&
  EMAILJS_TEMPLATE_ID &&
  !EMAILJS_TEMPLATE_ID.startsWith("YOUR_");

let initialized = false;
const ensureInit = () => {
  if (initialized) return true;
  if (!isConfigured()) return false;
  if (typeof window === "undefined" || !window.emailjs) return false;
  window.emailjs.init(EMAILJS_PUBLIC_KEY);
  initialized = true;
  return true;
};

/**
 * Send an inquiry email notification to the owner via EmailJS.
 * Resolves silently with `{ skipped: true }` when EmailJS is not yet
 * configured (so local development and previews keep working).
 */
export async function sendInquiryEmail(payload) {
  if (!ensureInit()) {
    // Not configured yet — surface a clear console hint without breaking flow.
    // eslint-disable-next-line no-console
    console.warn(
      "[EmailJS] Skipping email — not configured. Update /app/frontend/src/lib/emailjs.js with your Service ID, Template ID, and Public Key."
    );
    return { skipped: true };
  }
  return window.emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    payload
  );
}
